/* eslint-disable no-template-curly-in-string */
import yup from 'schemas/validation/feature'
import strings from 'utils/strings'
import {
  CAN,
  PIN,
  MIN_FREQUENCY,
  MAX_FREQUENCY,
  MIN_DUTY_CYCLE,
  MAX_DUTY_CYCLE,
  FEATURE_MODULE_NAMES_WITH_HARNESSES,
} from 'utils/constants'
import { isNil } from 'ramda'
import { INTERNAL } from 'constants/featureTypes'

import scalingQuerySchema from './scalingQuerySchema'
import {
  isPWM,
  isVariableDutyCycle,
  isVariableFrequency,
  isNotVariableDutyCycle,
  isNotVariableFrequency,
} from './utils'

const dutyCycle = yup.number().min(MIN_DUTY_CYCLE).max(MAX_DUTY_CYCLE)
const frequency = yup.number().min(MIN_FREQUENCY).max(MAX_FREQUENCY)

const outputSchema = yup.object().shape({
  id: yup.string().required(),
  polarity: yup.string().nullable(),
  current: yup.number().nullable(),
  virtualFuseSetting: yup.number(),
  resetAttempts: yup.number(),
  resetDelay: yup.number().nullable(),
  description: yup.string().required().unique().max(80),
  type: yup.string(),
  pinResult: yup.boolean(),
  isAwake: yup.boolean().nullable(),
  floatingCircuit: yup
    .string()
    .nullable()
    .when(['type', '$type', '$featureModuleName', '$featureType'], {
      is: (type, contextType, featureModuleName, featureType) =>
        (type === PIN || contextType === PIN) &&
        FEATURE_MODULE_NAMES_WITH_HARNESSES.includes(featureModuleName) &&
        featureType === INTERNAL,
      then: yup.string().requiredIfContext('mappedOutputId', isNil).nullable(),
    }),
  mappedOutputId: yup
    .string()
    .nullable()
    .requiredIfContext('floatingCircuit', isNil)
    .when(['type', '$type', '$featureModuleName', '$featureType'], {
      is: (type, contextType, featureModuleName, featureType) =>
        (type === PIN || contextType === PIN) &&
        FEATURE_MODULE_NAMES_WITH_HARNESSES.includes(featureModuleName) &&
        featureType === INTERNAL,
      then: yup
        .string()
        .requiredIfContext('floatingCircuit', isNil)
        .nullable()
        .hasIn('pinSet', strings.must_assign_harness),
    }),
  startBit: yup.number().nullable().when('type', {
    is: CAN,
    then: yup.number().required(),
  }),
  powerNetLevel: yup.number().nullable(),
  pwmMode: yup
    .number()
    .nullable()
    .when(['type', 'polarity'], (type, polarity, schema) => {
      if (type === 'pin' && isPWM(polarity)) {
        return schema.required().min(1).max(3)
      }

      return schema
    }),
  dutyCycle: dutyCycle.requiredIfContext('pwmMode', isNotVariableDutyCycle),
  dutyCycleMin: dutyCycle
    .requiredIfContext('pwmMode', isVariableDutyCycle)
    .lessThanContext('dutyCycleMax'),
  dutyCycleMax: dutyCycle
    .requiredIfContext('pwmMode', isVariableDutyCycle)
    .moreThanContext('dutyCycleMin'),
  frequency: frequency.requiredIfContext('pwmMode', isNotVariableFrequency),
  frequencyMin: frequency
    .requiredIfContext('pwmMode', isVariableFrequency)
    .lessThanContext('frequencyMax'),
  frequencyMax: frequency
    .requiredIfContext('pwmMode', isVariableFrequency)
    .moreThanContext('frequencyMin'),
  scalingQuery: scalingQuerySchema,
  value: yup.number().nullable(),
})

export default outputSchema
